'use client';
// À la signature de la vérification : « avez-vous modifié le document ? » (RQ, 03/10/2026).
// La réponse part au moteur, qui l'inscrit au journal signé et sur la version.
import React from 'react';
import { Modale, inputStyle } from '@/components/ui';

import { Bouton } from '@/shared/Bouton';
export interface DeclarationModifs { modifie: boolean; description: string }

const MIN = 10;

export function ModaleVerification({ dejaEnregistre, occupe, onAnnuler, onSigner }: {
  /** Le moteur a déjà vu des enregistrements du vérificateur sur cette version. */
  dejaEnregistre: boolean; occupe: boolean;
  onAnnuler: () => void; onSigner: (d: DeclarationModifs) => void;
}) {
  const [modifie, setModifie] = React.useState<boolean | null>(dejaEnregistre ? true : null);
  const [description, setDescription] = React.useState('');
  const trop = modifie === true && description.trim().length < MIN;
  const pret = modifie !== null && !trop;
  return (
    <Modale titre="Avant de signer la vérification" largeur={520} onClose={onAnnuler}
      pied={<>
        <Bouton taille="sm" type="button" onClick={onAnnuler} disabled={occupe}>Annuler</Bouton>
        <Bouton variante="primaire" type="button" disabled={!pret || occupe} onClick={() => onSigner({ modifie: modifie === true, description: modifie ? description.trim() : '' })}>
          {occupe ? 'Signature en cours…' : 'Signer la vérification'}
        </Bouton>
      </>}>
      <div style={{ display: 'grid', gap: 12, fontSize: 13.5, color: 'var(--text-body)' }}>
        <p style={{ margin: 0, lineHeight: 1.55 }}>
          Avez-vous <strong>modifié</strong> le document pendant la vérification ? Votre réponse est inscrite au journal signé
          et sur la version ; le suivi des modifications de l’éditeur garde le détail.
        </p>
        {dejaEnregistre && (
          <p style={{ margin: 0, fontSize: 12.5, color: 'var(--amber-700, #8A5B00)' }}>
            Des enregistrements faits sous votre nom figurent déjà à cette version : décrivez-les.
          </p>
        )}
        <div role="radiogroup" aria-label="Modifications du vérificateur" style={{ display: 'grid', gap: 6 }}>
          <label style={{ display: 'flex', gap: 8, alignItems: 'center', opacity: dejaEnregistre ? 0.5 : 1 }}>
            <input type="radio" name="modifs" checked={modifie === false} disabled={dejaEnregistre} onChange={() => setModifie(false)} />
            Non, aucune modification
          </label>
          <label style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input type="radio" name="modifs" checked={modifie === true} onChange={() => setModifie(true)} />
            Oui, j’ai retouché le document
          </label>
        </div>
        {modifie === true && (
          <label style={{ display: 'grid', gap: 4, fontSize: 12.5, color: 'var(--text-muted)' }}>
            Décrivez brièvement ce que vous avez modifié ({MIN} caractères au moins)
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3}
              style={{ ...inputStyle, height: 'auto', padding: '8px 10px', resize: 'vertical' }} autoFocus />
          </label>
        )}
      </div>
    </Modale>
  );
}
